import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import { filterBoolean } from '@recruitee/common';

import type { Source } from '../../../types';
import { SourceActions, SourceSelectors } from './source.store';

@Injectable({ providedIn: 'root' })
export class SourceStoreService {
  constructor(private store: Store) {}

  public getSources(): Observable<Source[]> {
    return this.store.select(SourceSelectors.entities()).pipe(filterBoolean);
  }

  public getSourcesLoading(): Observable<boolean> {
    return this.store.select(SourceSelectors.isPending());
  }

  public getSourcesFailed(): Observable<boolean> {
    return this.store.select(SourceSelectors.isFailed());
  }

  public fetchSources(): void {
    this.store.dispatch(SourceActions.fetchCollection());
  }
}
